import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row g-2" }


export default {
  __name: 'KpiSkeletonRow',
  props: {
  count: {
    type: Number,
    default: 4,
  },
},
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.count, (n) => {
      return (_openBlock(), _createElementBlock("div", {
        key: n,
        class: "col-sm-6 col-lg-3"
      }, [...(_cache[0] || (_cache[0] = [
        _createStaticVNode("<div class=\"kpi-skeleton-card\" data-v-f5c36590><div class=\"kpi-skeleton-header\" data-v-f5c36590><div class=\"skeleton skeleton-title\" data-v-f5c36590></div><div class=\"skeleton skeleton-icon\" data-v-f5c36590></div></div><div class=\"skeleton skeleton-value\" data-v-f5c36590></div><div class=\"skeleton skeleton-footer\" data-v-f5c36590></div></div>", 1)
      ]))]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

}